import React, { useEffect, useState } from 'react';
import { IconLoader } from 'icons';
import { FormattedMessage } from 'react-intl';
import camelize from 'camelize';
import { queryCanTwitterDm } from 'api/platformMention';
import { useSelector } from 'react-redux';
import { RootState } from 'redux/ducks';

interface Props {
  username: string;
  theme?: 'settings';
}

interface CheckDmState {
  isChecking: boolean;
  canDm: boolean | null;
}

export default function TwitterDmStatus(props: Props) {
  const { username, theme } = props;
  const [checkDmState, setCheckDmState] = useState<CheckDmState>({
    isChecking: false,
    canDm: null,
  });
  const { isChecking, canDm } = checkDmState;
  const { suggester } = useSelector((state: RootState) => ({
    suggester: state.suggester!,
  }));

  const suggesterAccount = suggester.config.twitterDmAccounts[0];

  const classNames =
    theme === 'settings' ? 'bg-grey7 rounded p-2 text-dark' : '';

  useEffect(() => {
    const checkDm = async () => {
      setCheckDmState({ isChecking: true, canDm: null });
      try {
        const data = camelize(await queryCanTwitterDm(username));
        setCheckDmState({ isChecking: false, canDm: data.canDm });
      } catch (e) {
        console.error(e);
        setCheckDmState({ isChecking: false, canDm: false });
      }
    };

    if (suggesterAccount && canDm === null && !isChecking) checkDm();
  }, [canDm, isChecking, suggesterAccount, username]);

  if (!suggesterAccount) return null;

  const linkClassName =
    theme === 'settings' ? 'text-socialiePink' : 'text-dark';

  const linkToAccount = (
    <a
      href={`https://twitter.com/${suggesterAccount}`}
      className={`hover:underline ${linkClassName}`}
      target="_blank"
      rel="noopener noreferrer"
    >
      @{suggesterAccount}
    </a>
  );

  return (
    <div className={`text-left text-14 ${classNames}`}>
      {isChecking ? (
        <IconLoader className="block w-1.5 h-1.5" />
      ) : canDm ? (
        <FormattedMessage
          id="ManageNotifications__CanDm"
          values={{
            account: linkToAccount,
            accountName: suggester.accountName,
          }}
        />
      ) : (
        <FormattedMessage
          id="ManageNotifications__CannotDm"
          values={{
            account: linkToAccount,
            accountName: suggester.accountName,
          }}
        />
      )}
    </div>
  );
}
